import { IPinRepository } from '../../sharebase/services/pinRepoService';	

// https://regex101.com/r/Qbbibg/1
const urlPattern = /(f|documents)\/shares\/(\S+)\/(\d+)\/auth/i;
export function PinTokenInterceptor($q:ng.IQService, sbPinRepo:IPinRepository){
	function onRequest(config:ng.IRequestConfig) {				
		let pinToken:any;
		if(pinToken = verifyMatch(config)) {
			// reuse pin token since it can only be validated once
			if(sbPinRepo.has(pinToken)){
				return $q.reject(sbPinRepo.get(pinToken));
			} else {
				return config;
			}		
		}
		return config;
	}

	function onResponse(response){
		let pinToken:any;
		if(pinToken = verifyMatch(response.config)) {
			sbPinRepo.set(pinToken, response.data);
		}

		return response;
	}

	function onResponseError(err:any){
		if(err.UserName === 'ShareByLinkUser'){
			return {
				data: err
			};
		} else {
			return $q.reject(err);
		}
	}

	function verifyMatch(config:ng.IRequestConfig){
		let matches = config.url.match(urlPattern);
		return config.method === 'POST' && matches && matches.length === 4 ? matches[2] : false;
	}

	return {
		request: onRequest,
		response: onResponse,
		responseError: onResponseError
	};
}

PinTokenInterceptor.$inject = [
	'$q', 
	'sbPinRepo'
];


// WEBPACK FOOTER //
// ./src/sharebase-app/interceptors/pinTokenInterceptor.ts